import React from "react";

const AccordionVideo = ({ videos, onVideoSelect }) => {
  return (
    <div className="video-circle-container">
      {videos.map((video, index) => (
        <div
          key={index}
          className="video-circle"
          onClick={() => onVideoSelect(video.id)}
        >
          <img
            src={`https://img.youtube.com/vi/${video.id}/maxresdefault.jpg`}
            alt={`YouTube Video ${index + 1}`}
          />
        </div>
      ))}
    </div>
  );
};

export default AccordionVideo;
